import cardsalesApi from '@/api/now/cardsalesApi'

import LoanService from '@/service/loan/LoanService'

import store from '@/store'

const BAEMIN = 'baemin'
const statuses = {
  NOT_DEFIEND: {
    component: 'DeliveryNotDefined',
    code: 'not_defined',
    down: '추가 한도 확인 >',
    route: 'ordersales'
  },
  PENDING: {
    component: 'DeliveryPending',
    code: 'pending',
    down: '연결하기 >'
  },
  IN_PROGRESS: {
    component: 'DeliveryInProgress',
    code: 'in_progress',
    down: '연결중'
  },
  COMPLETED: {
    component: 'DeliveryCompleted',
    code: 'completed',
    down: '배민 매출 연결 완료'
  }
}

let deliveryService = {
  init() {
    store.dispatch('delivery/setStatus', {
      template: statuses.NOT_DEFIEND
    })
    store.dispatch('delivery/setCurrentComponent', statuses.NOT_DEFIEND.component)
  },
  async getDeliveryCredential() {
    let { data } = await cardsalesApi.getCredentials()
    data.forEach(async (credential) => {
      if (credential.provider === BAEMIN) {
        store.dispatch('delivery/setCredentialId', credential.uuid)
        store.dispatch('delivery/setCurrentComponent', statuses[credential.status.toUpperCase()].component)
        store.dispatch('delivery/setStatus', {
          template: statuses[credential.status.toUpperCase()]
        })
        await this.getDeliveryOffer()
      }
    })
  },
  async getDeliveryOffer() {
    let status = store.getters['delivery/getStatus']
    if ([statuses.PENDING.code, statuses.IN_PROGRESS.code].includes(status.code)) {
      return
    }
    let currentOffer = store.getters['loan/getOffer']
    if (!currentOffer) {
      return
    }

    let tempOffer = await LoanService.getCurrentTempOffer()
    let deliveryOffer = tempOffer.amount - currentOffer.amount
    if (deliveryOffer < 0) {
      deliveryOffer = 0
    }

    store.dispatch('delivery/setTempOfferStatus', tempOffer.status)
    store.dispatch('delivery/setOffer', deliveryOffer)
  },
  async connect() {
    try {
      let credentialId = store.getters['delivery/getCredentialId']
      await cardsalesApi.patchCredentialsConnect(credentialId)
    } catch (e) {
      console.log('connect', e)
    }
  }
}
export default deliveryService
